var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1014.7 1014.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clippath);}.cls-2,.cls-3,.cls-4,.cls-5{stroke-width:0px;}.cls-2,.cls-6{fill:none;}.cls-3{fill:#cdf1f3;}.cls-4{fill:#fff;}.cls-6{stroke:#cdf1f3;stroke-miterlimit:10;stroke-width:3px;}.cls-5{fill:#ff6c00;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 1014.7,
    height: 1014.7
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M736.7-1418.1c0-77.9,63.1-141,141-141l5005.2-.8c47.7,0,93.1,20.7,124.3,56.7l253.4,292.2c29.6,34.1,45.9,77.8,46,123l1.2,1303.8c0,50.5-18,99.3-50.7,137.6l-244.3,285.9c-31.3,36.6-77,57.6-125,57.6H877.7c-77.9,0-141-63.1-141-141v-1974Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M720.5,907.4c0-77.9,63.1-141,141-141l5005.2-.8c47.7,0,93.1,20.7,124.3,56.7l253.4,292.2c29.6,34.1,45.9,77.8,46,123l1.2,1303.8c0,50.5-18,99.3-50.7,137.6l-244.3,285.9c-31.3,36.6-77,57.6-125,57.6H861.5c-77.9,0-141-63.1-141-141V907.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M-4904.4-1872.9c0-77.9,63.1-141,141-141l5005.2-.8c47.7,0,93.1,20.7,124.3,56.7l253.4,292.2c29.6,34.1,45.9,77.8,46,123l1.2,1303.8c0,50.5-18,99.3-50.7,137.6l-244.3,285.9c-31.3,36.6-77,57.6-125,57.6h-5010c-77.9,0-141-63.1-141-141v-1974Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M-4946.2-1174.9c0-77.9,63.1-141,141-141l5005.2-.8c47.7,0,93.1,20.7,124.3,56.7l253.4,292.2c29.6,34.1,45.9,77.8,46,123l1.2,1303.8c0,50.5-18,99.3-50.7,137.6l-244.3,285.9c-31.3,36.6-77,57.6-125,57.6h-5010c-77.9,0-141-63.1-141-141v-1974Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 625.2,
    cy: 259.8,
    r: 79.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 201,
    cy: 1076.3,
    r: 267.9
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginDesktop);
export default __webpack_public_path__ + "static/media/login_desktop.afd98902d1639f648b44cfb97b60f25b.svg";
export { ForwardRef as ReactComponent };